/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { classNameBindings, classNames } from '@ember-decorators/component';
import Component from '@ember/component';

@classNames('group-profile-image', 'layout-row', 'layout-wrap')
@classNameBindings(
  'singleRow:layout-align-end-start:layout-align-center-center',
)
export default class GroupProfileImage extends Component {
  // singleRow specifies whether to apply styles which assume a lack of space
  // to wrap to a second row of profile images.
  singleRow = false;
}
